(function () {
  var MOBILE_QUERY = '(max-width: 767px)';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getSlideCount(root) {
    var count = parseInt(root.getAttribute('data-slide-count') || '0', 10);
    return Number.isFinite(count) ? count : 0;
  }

  function SydneyMarathon2026Recap(root) {
    this.root = root;
    this.swiper = null;
    this.mediaQuery = window.matchMedia(MOBILE_QUERY);
    this.onMediaChange = this.handleMediaChange.bind(this);
    this.createSwiper();

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.onMediaChange);
    } else {
      this.mediaQuery.addListener(this.onMediaChange);
    }
  }

  SydneyMarathon2026Recap.prototype.createSwiper = function () {
    if (typeof Swiper === 'undefined' || !isMobile()) return;

    var swiperEl = this.root.querySelector('.sydney-marathon-2026-recap__swiper');
    var slideCount = getSlideCount(this.root);
    if (!swiperEl || slideCount < 2) return;

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: slideCount > 1,
      speed: 450,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: this.root.querySelector('.sydney-marathon-2026-recap__pagination'),
        clickable: true
      },
      navigation: {
        nextEl: this.root.querySelector('.sydney-marathon-2026-recap__nav-btn--next'),
        prevEl: this.root.querySelector('.sydney-marathon-2026-recap__nav-btn--prev')
      }
    });
  };

  SydneyMarathon2026Recap.prototype.destroySwiper = function () {
    if (!this.swiper) return;
    this.swiper.destroy(true, true);
    this.swiper = null;
  };

  SydneyMarathon2026Recap.prototype.handleMediaChange = function () {
    this.destroySwiper();
    this.createSwiper();
  };

  function bootAll() {
    if (typeof Swiper === 'undefined') {
      window.addEventListener('load', bootAll, { once: true });
      return;
    }

    document.querySelectorAll('.sydney-marathon-2026-recap').forEach(function (el) {
      if (el._sm2026Recap) return;
      el._sm2026Recap = new SydneyMarathon2026Recap(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
